/**
 * @desc 通过sku和供应商IdName列表获取sku物流信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.srm.SkuAndSupplierIdNameRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/logisticsSku/bySkuAndSupplierList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
